import tinymce from "tinymce";
import Rails from "@rails/ujs";

const uploadUrl = "/superusers/tinymce_images";
const imageUploadHandler = (blobInfo, progress) =>
  new Promise((success, failure) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", uploadUrl);
    xhr.withCredentials = false;
    Rails.CSRFProtection(xhr);
    xhr.upload.onprogress = (e) => {
      progress((e.loaded / e.total) * 100);
    };
    xhr.onerror = () => {
      failure(
        "Image upload failed due to a XHR Transport error. Code: " + xhr.status
      );
    };
    xhr.onload = () => {
      if (xhr.status < 200 || xhr.status >= 300) {
        failure("HTTP Error: " + xhr.status);
        return;
      }
      const json = JSON.parse(xhr.responseText);
      if (!json || typeof json.location != "string") {
        failure("Invalid JSON: " + xhr.responseText);
        return;
      }
      success(json.location);
    };

    const now = new Date();
    const timestampSeconds = Math.floor(now.getTime() / 1000); // Get timestamp in seconds (rounded down)

    const formData = new FormData();
    let idElement = document.getElementById("rich-text-id");
    const richTextId = idElement.dataset.richTextId;
    const extension = blobInfo
      .filename()
      .slice(((blobInfo.filename().lastIndexOf(".") - 1) >>> 0) + 2);

    const timestampFilename =
      "richTextId" +
      richTextId +
      "imageTimestamp" +
      timestampSeconds +
      "." +
      extension;

    formData.append("file", blobInfo.blob(), timestampFilename);
    formData.append("rich_text_id", richTextId);
    xhr.send(formData);
  });

tinymce.init({
  selector: ".rich-text",
  plugins: "code image link",
  toolbar: [
    { name: "history", items: ["undo", "redo"] },
    { name: "styles", items: ["styles"] },
    { name: "formatting", items: ["bold", "italic"] },
    {
      name: "alignment",
      items: ["alignleft", "aligncenter", "alignright", "alignjustify"]
    },
    { name: "indentation", items: ["outdent", "indent"] },
    { name: "links", items: ["link"] },
    { name: "images", items: ["image"] }
  ],
  paste_webkit_styles: "all",
  paste_as_text: false,
  smart_paste: false,
  paste_data_images: true,
  base_url: "/tinymce",
  image_file_types: "svg,jpeg,jpg,png,gif",
  images_upload_handler: imageUploadHandler,
  images_reuse_filename: true,
  file_picker_types: "image",
  file_picker_callback: function (callback, value, meta) {
    if (meta.filetype === "image") {
      let input = document.createElement("input");
      input.setAttribute("type", "file");
      input.setAttribute("accept", "image/*, .svg");
      input.click();
      input.onchange = function () {
        let file = input.files[0];
        let reader = new FileReader();

        reader.onload = function (e) {
          let base64Image = e.target.result;
          callback(base64Image);
        };
        reader.readAsDataURL(file);
      };
    }
  }
});

//  Copyright © 2018 by Northwestern University. All Rights Reserved.
